import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';

export type DividerColor = 'light' | 'dark';

const dividerTextColor: Record<DividerColor, string> = {
  light: '#8c8c8d',
  dark: '#404042',
};
const dividerLineColor: Record<DividerColor, string> = {
  light: '#d9d9d9',
  dark: '#8c8c8d',
};

interface DividerProps {
  className?: string;
  isOr?: boolean;
  color?: DividerColor;
  margin?: number;
}

export const Divider = ({
  className,
  isOr = true,
  color = 'light',
  margin = 0,
}: DividerProps) => {
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: sp[8],
        width: '100%',
        color: dividerTextColor[color],
        typography: 'bodyXs',
        m: `${margin}px 0`,
      }}
    >
      <Box
        sx={{ borderBottom: `1px solid ${dividerLineColor[color]}`, flex: 1 }}
      />
      {isOr && (
        <>
          OR
          <Box
            sx={{
              borderBottom: `1px solid ${dividerLineColor[color]}`,
              flex: 1,
            }}
          />
        </>
      )}
    </Box>
  );
};

Divider.displayName = 'Divider';

export default Divider;
